import { Outlet } from "react-router-dom";
import { useIsMobile } from "@/hooks/useIsMobile";
import { BottomTabBar } from "./BottomTabBar";

export function MobileShell() {
  const isMobile = useIsMobile();

  /*
    데스크톱에서도 높이를 여기서 준다. 자식이 각자 h-dvh 를 쓰면 모바일에서 그 값이
    하단 탭 바 자리까지 먹어 바가 0 높이로 눌린다 — 실제로 그랬다.
    높이의 주인을 하나로 두고 자식은 h-full 만 쓴다.
  */
  if (!isMobile) {
    return (
      <div className="h-dvh w-full">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-dvh flex-col bg-[var(--surface-sunken)]">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </div>
      <BottomTabBar />
    </div>
  );
}
